import { MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-components';
import { toJS } from 'mobx';
import React from 'react';
import { getPageStore } from '../../@data/store/store';
import { useDataDelay } from '../../hooks/useReportQuery';

interface IDelayMessageBarContentProps {
  delayedReports: string[];
}

const DelayMessageBarContent = ({ delayedReports }: IDelayMessageBarContentProps) => {
  const { reports: mobxReports } = getPageStore();
  const allReports = toJS(mobxReports)
    .map((section) => section.items)
    .flat();

  const uniqueReports = delayedReports
    .map((report) => allReports.find((r) => r.id.toLocaleLowerCase() === report.toLocaleLowerCase())?.name || report)
    .filter((report, index, self) => self.findIndex((r) => r === report) === index);

  if (uniqueReports.length === 0) {
    return null;
  }

  const title =
    uniqueReports.length === 1
      ? `${uniqueReports[0]} data is delayed.`
      : `${uniqueReports.length} reports are delayed due to a data issue.`;
  const body =
    uniqueReports.length === 1
      ? `This report is available, but the latest data is delayed.`
      : `${uniqueReports
          .map((report) => report)
          .join(', ')
          .replace(/([^, ]*)$/, ' $1')} reports are available, but the latest data is delayed.`;

  return (
    <MessageBar>
      <MessageBarBody>
        <MessageBarTitle>{title}</MessageBarTitle>
        {body}
      </MessageBarBody>
    </MessageBar>
  );
};
export interface IReportDataDelayMessageBarProps {
  reportName: string;
}

export const ReportDataDelayMessageBar = ({ reportName }: IReportDataDelayMessageBarProps) => {
  return <DelayMessageBarContent delayedReports={[reportName]} />;
};
export interface IOverviewDataDelayMessageBarProps {
  reportTypes: string[];
  startDate: string;
  endDate: string;
}

export const OverviewDataDelayMessageBar = ({ reportTypes, startDate, endDate }: IOverviewDataDelayMessageBarProps) => {
  const { data, isError, isLoading } = useDataDelay(reportTypes, startDate, endDate);

  if (!data || isError || isLoading) {
    return null;
  }

  // const delayedReports = data.filter((report) => report.OutOfSLA);
  return <DelayMessageBarContent delayedReports={data.map((report) => report.ReportName)} />;
};
